import React, { useState } from 'react';
import { BrowserRouter, Routes, Route, Navigate, useNavigate } from "react-router-dom";
import Navbar from './components/common/Navbar';
import Login from './pages/Login_Signup/index.js';
import Home from "./Home";
import Dashboard from './pages/Dashboard/Dashboard.js';
import RegistrationPage from './components/auth/RegistrationPage';
import UserManagementPage from './components/userspage/UserManagementPage';
import UpdateUser from './components/userspage/UpdateUser';
import FooterComponent from './components/common/Footer';
import UserService from './components/service/UserService';
import Sidebar from './components/Sidebar/Sidebar';
import SignUp from './pages/Login_Signup/SignUp.js';
import Header from './components/Header/Header.js';
import ServiceRequests from './pages/ServiceRequests';  // Make sure to import the component
import ServiceProviders from './pages/ServiceProvider';  // Assuming this exists
import HomeOwners from './pages/Homeowner';

const App = () => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false); // Track admin status
  const navigate = useNavigate(); // Initialize useNavigate

  const handleLogin = (value) => {
    setIsLoggedIn(value);
    if (value) {
      setIsAdmin(UserService.adminOnly()); // Check if the user is an admin
      navigate("/dashboard"); // Redirect to dashboard on login
    }
  };

  return (
    <div className="App">
      {isLoggedIn && <Header />}
      {isLoggedIn && <Sidebar />}
      <div className="content">
        <Routes>
          <Route path="/" element={<Login handleLogin={handleLogin} />} />
          <Route path="/login" element={<Login handleLogin={handleLogin} />} />
          <Route path="/signup" element={<SignUp />} /> {/* Make this always available */}
          {!isLoggedIn ? (
            <Route path="*" element={<Navigate to="/login" />} />
          ) : (
            <>
              <Route path="/" element={<Home handleLogin={handleLogin} />} />
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/service" element={<ServiceProviders />} />
            <Route path="/homeowner" element={<HomeOwners />} />
            <Route path="/serviceRequests" element={<ServiceRequests />} />
            
              {isAdmin && ( // Only show admin routes if user is an admin
                <>
                  <Route path="/register" element={<RegistrationPage />} />
                  <Route path="/admin/user-management" element={<UserManagementPage />} />
                  <Route path="/update-user/:userId" element={<UpdateUser />} />
                </>
              )}
              <Route path="*" element={<Navigate to="/dashboard" />} /> {/* Redirect to dashboard for unknown routes */}
            </>
          )}
        </Routes>
      </div>
      {isLoggedIn && <FooterComponent />}
    </div>
  );
}

const AppWithRouter = () => {
  return (
    <BrowserRouter>
      <App />
    </BrowserRouter>
  );
};

export default AppWithRouter;
